// 12.06.25 14:30 - Updated SideDrawer to always-visible layout with Drawing Practice
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
// 26.11.25 AEST - White logo for dark sidebar
import coocLogo from '../../assets/cooc-logo-white.PNG';
import './SideDrawer.css';

const SideDrawer = ({ isOpen, onClose }) => {
  const location = useLocation();
  const { currentUser, logout } = useAuth();

  // 12.06.25 14:30 - Helper function to determine active menu item
  const getNavLinkClass = (path) => {
    return location.pathname === path ? 'nav-item active' : 'nav-item';
  };

// 23.09.25 17:45 AEST - Fixed navigation conflicts
const handleLogout = async () => {
  try {
    console.log('23.09.25 17:45 - Starting logout...');
    
    await logout();
    localStorage.clear();
    sessionStorage.clear();
    
    console.log('23.09.25 17:45 - Logout successful');
    
    // Single redirect method to avoid conflicts
    setTimeout(() => {
      window.location.replace('/cooc-login.html');
    }, 100);
    
  } catch (error) {
    console.error('23.09.25 17:45 - Logout error:', error);
    localStorage.clear();
    sessionStorage.clear();
    window.location.replace('/cooc-login.html');
  }
};

  return (
    // 12.06.25 14:30 - Removed overlay and slide animations, now always visible
    <aside className="sidebar-always-visible">
    <div className="sidebar-header">
      <div className="logo-section">
  <div 
    className="cooc-logo-image" 
    style={{ backgroundImage: `url(${coocLogo})` }}
  ></div>
  <h1 className="app-logo">COOC</h1>
  <p className="app-tagline">Control | Own<br />Organise | Connect</p>
</div>
        
        {/* 12.06.25 14:30 - User profile section */}
        <div className="user-profile">
          <div className="user-avatar">
            {currentUser?.email?.charAt(0)?.toUpperCase() || 'U'}
          </div>
          <div className="user-info">
          <span className="user-email">
  {currentUser?.email?.split('@')[0] || 'User'}
</span>
            <span className="user-status">Online</span>
          </div>
        </div>
      </div>

      {/* 12.06.25 14:30 - Main navigation menu */}
      <nav className="sidebar-nav">
        <Link to="/" className={getNavLinkClass('/')} onClick={onClose}>
          <span className="nav-icon">🏠</span>
          <span className="nav-label">Home</span>
        </Link>

        <Link to="/files" className={getNavLinkClass('/files')} onClick={onClose}>
          <span className="nav-icon">📁</span>
          <span className="nav-label">Files</span>
        </Link>

        <Link to="/emails" className={getNavLinkClass('/emails')} onClick={onClose}>
          <span className="nav-icon">📧</span>
          <span className="nav-label">Emails</span>
        </Link>

        <Link to="/upload" className={getNavLinkClass('/upload')} onClick={onClose}>
          <span className="nav-icon">⬆️</span>
          <span className="nav-label">Upload</span>
        </Link>

{/* 28.11.25 14:00 AEST - Drawing Practice disabled, showing Coming Soon */}
<div className="nav-item coming-soon-item" title="Coming Soon">
          <span className="nav-icon">✏️</span>
          <span className="nav-label">Drawing Practice</span>
          <span className="coming-soon-badge">Soon</span>
        </div>

{/* 28.11.25 14:00 AEST - Noticeboard disabled, showing Coming Soon */}
<div className="nav-item coming-soon-item" title="Coming Soon">
          <span className="nav-icon">💬</span>
          <span className="nav-label">Noticeboard</span>
          <span className="coming-soon-badge">Soon</span>
        </div>

        <Link to="/reminders" className={getNavLinkClass('/reminders')} onClick={onClose}>
          <span className="nav-icon">⏰</span>
          <span className="nav-label">Reminders</span>
        </Link>

        <Link to="/goals" className={getNavLinkClass('/goals')} onClick={onClose}>
          <span className="nav-icon">🎯</span>
          <span className="nav-label">Goals</span>
        </Link>
        
        {/* 12.06.25 14:30 - Divider for settings section */}
        <div className="nav-divider"></div>

        <Link to="/account" className={getNavLinkClass('/account')} onClick={onClose}>
          <span className="nav-icon">👤</span>
          <span className="nav-label">Account</span>
        </Link>

        <Link to="/settings" className={getNavLinkClass('/settings')} onClick={onClose}>
          <span className="nav-icon">⚙️</span>
          <span className="nav-label">Settings</span>
        </Link>

        {/* 12.06.25 14:30 - Logout button */}
        <button className="nav-item logout-button" onClick={handleLogout}>
          <span className="nav-icon">🚪</span>
          <span className="nav-label">Logout</span>
        </button>
      </nav>

{/* 28.11.25 15:00 AEST - Added privacy policy link */}
<div className="sidebar-footer">
        <p className="app-version">COOC v1.7</p>
        <a href="/privacy-policy.html" target="_blank" className="privacy-link">Privacy Policy</a>
        <p className="copyright">© 2025 Manly House</p>
      </div>
    </aside>
  );
};

export default SideDrawer;